import React from 'react';
import AreaIndicatorChart from './AreaIndicatorChart';
import QualitativeChartFactory from '../../charting/qual/QualitativeChartFactory';

const Qualitative_AreaIndicatorChart = ({ areaIndicator }) => {
    return (
        <AreaIndicatorChart 
            areaIndicator={areaIndicator} 
            ChartFactory={QualitativeChartFactory} 
            indicatorType="QUALITATIVE" 
        />
    );
};

export default Qualitative_AreaIndicatorChart;